module.exports = __webpack_public_path__ + "img/bannerweapon.e42c9493.png";